export default {
    controller: 'registerController',
    template: require('../views/register.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/register.component.js